import { ThrowStmt } from '@angular/compiler';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RegistrosCorreosEnviadosRecibos, CuentasEnvioRecibos, CatRutas, CatTipoPeriodos, CatVencimientos, CatVencimientosInput, ConsultaLecturasInput, FCuentasEnvioMasivoRecibos, FCuentasEnvioMasivoRecibosInput, ProximaAsignacionInput } from 'app/entidades/entidades';
import { CatRutasService } from 'app/servicios/cat-rutas.service';
import { CatTipoPeriodosService } from 'app/servicios/cat-tipo-periodos.service';
import { FCuentasEnvioMasivoRecibosService } from 'app/servicios/f-cuentas-envio-masivo-recibos.service';
import { ProximaAsignacionService } from 'app/servicios/proxima-asignacion.service';
import { RegistrosCorreosEnviadosRecibosService } from 'app/servicios/registros-correos-enviados-recibos.service';
import { VencimientosLecturaService } from 'app/servicios/vencimientos-lectura.service';
import { MuestraMensaje } from 'app/shared/utilerias/notificaciones/notificaciones.component';
import { ConfirmationService, MenuItem, SelectItem } from "primeng/api";

@Component({
  selector: 'app-envio-masivo-recibo',
  templateUrl: "./envio-masivo-recibo.component.html",
  styleUrls: ['./envio-masivo-recibo.component.css'],

})
export class EnvioMasivoReciboComponent implements OnInit{ 
   muestraMensaje = new MuestraMensaje();

  public ruta: CatRutas;
  public catRutas: CatRutas[] = [];
  public catTipoperiodo: CatTipoPeriodos[] = [];
  public PeriodoSeleccionado: CatTipoPeriodos = new CatTipoPeriodos();
  public anios: CatVencimientos[] = [];
  public anioSeleccionado: CatVencimientos;
  public bimestre: CatVencimientos[] = [];
  public bimestreSeleccionado: CatVencimientos;
  public catVencimientosLecturasInputAnio: CatVencimientosInput = new CatVencimientosInput();
  public catVencimientosLecturasInputPeriodo: CatVencimientosInput = new CatVencimientosInput();
  public proximaasignacion: ProximaAsignacionInput = new ProximaAsignacionInput();
  public consultaLectura: ConsultaLecturasInput;
  public itemsMenu: MenuItem[];
  public fCuentasEnvioMasivoRecibos: FCuentasEnvioMasivoRecibos[];
  public columnasTabla: any[];
  public FCuentasEnvioMasivoRecibosInput: FCuentasEnvioMasivoRecibosInput = new FCuentasEnvioMasivoRecibosInput();
  public numsRows: any[] = [];
  public CuentasSinCorreo: number = 0;
  public CuentasConCorreo: number = 0;
  public progressBar: boolean = false;
  public progressBarRegistro: boolean = false;  
  public fcuentasAenviar: FCuentasEnvioMasivoRecibos[] = [];
  public registrosCorreosEnviadosRecibos: RegistrosCorreosEnviadosRecibos = new RegistrosCorreosEnviadosRecibos();

  constructor
    (
      private catRutasService: CatRutasService,
      private vencimientosLecturaService: VencimientosLecturaService,
      private catTipoPeriodoService: CatTipoPeriodosService,
      private proximaAsignacionService: ProximaAsignacionService ,
      private fCuentasEnvioMasivoRecibosService: FCuentasEnvioMasivoRecibosService,
      private confirmationService: ConfirmationService,
      private registrosCorreosEnviadosRecibosService: RegistrosCorreosEnviadosRecibosService,
    ){
  }

  async ngOnInit() {
    this.getCatRutas();

    // ===============================================================
    //Opciones del menu de talbla
    // ===============================================================
    this.itemsMenu = [
      {label: "Envia Correo",   icon: "pi pi-file-o",  command: () =>  this.confirmaEnvio(), },
    ];
    
    // ===============================================================
    //Opciones de la columnas de tabla
    // ===============================================================
    this.columnasTabla = [
      {field: "Checkbox",header: "", ordenar: false, styleHeader: "width: 30px;"},
      //{field: "idAgua", header: "Agua",ordenar: true, styleHeader: "width: 150px;",},
      {field: "cuentaAgua", header: "Cuenta Agua",ordenar: true, styleHeader: "width: 150px;",},
      {field: "correoElectronico1", header: "Correo Electronico 1",ordenar: true, styleHeader: "width: 200px;",},
      {field: "correoLectronico2", header: "Correo Lectronico 2",ordenar: true, styleHeader: "width: 200px;",},
      {field: "anio", header: "Anio",ordenar: true, styleHeader: "width: 80px;",},
      {field: "periodoParcialidad", header: "Periodo Parcialidad",ordenar: true, styleHeader: "width: 80px;",},
      {field: "mesPeriodo", header: "Mes Periodo",ordenar: true, styleHeader: "width: 110px;",},
      {field: "fechaVencimiento", header: "Fecha Vencimiento",ordenar: true, styleHeader: "width: 110px;",},
      {field: "propietario", header: "Propietario",ordenar: true, styleHeader: "width: 150px;",},
      {field: "domiciolio", header: "Domiciolio",ordenar: true, styleHeader: "width: 350px;",},
    ];

  }

  async getCatRutas() {
    const datoRetorno = await this.catRutasService.getRutasFiltradasCosumusosVigentes().toPromise() 
    this.catRutas = datoRetorno;
    this.catRutas.unshift({ numRow: null, id: null, descripcion: 'SELECCIONA...', dato: "", fechaCorte: null });
  }

  async buscaAnio(zona: CatRutas) {
    try 
    {
      await this.getTipoPeriodo();
      this.catVencimientosLecturasInputAnio = new CatVencimientosInput();
      if (!zona) return;
      if (zona) {
          this.catVencimientosLecturasInputAnio._zona = zona.id.toString();
      }
      
      const datoRetorno = await this.vencimientosLecturaService.getBusquedas(this.catVencimientosLecturasInputAnio).toPromise();
  
      this.anios = datoRetorno;
      this.anios.unshift({ numRow: null, anio: 'SELECCIONA...', periodo: null });

      this.buscaPeriodo();
      this.buscaProximaAsignacion(zona.id);
    } catch (error) {
        throw error;
    }      
  }

  async buscaProximaAsignacion(idAguaZona: number)
  {
    try {
        this.proximaasignacion = new ProximaAsignacionInput();
        this.proximaasignacion.idAguaZona = idAguaZona;
        this.proximaasignacion.actual =  true;
          
        const datoRetorno = await this.proximaAsignacionService.postOperaciones(this.proximaasignacion).toPromise();
        if(datoRetorno){
            this.anioSeleccionado = this.anios.find(x=>x.anio === datoRetorno[0].anio.toString());   

            await this.buscaPeriodo() ;
            console.log("this.bimestre this.bimestre",this.bimestre);
            
            if(this.bimestre)
                this.bimestreSeleccionado = this.bimestre.find(x=>x.periodo === datoRetorno[0].periodoParcialidad.toString())  
        }
        console.log("datoRetorno", datoRetorno)
    } catch (error) {
        throw error;
    }
  }

  async buscaPeriodo() {
    
    if (!this.anioSeleccionado?.anio) return;
    
    if (!this.ruta?.id) return;
   
    if (!this.PeriodoSeleccionado?.id) return;

    this.bimestre = [];

    this.catVencimientosLecturasInputPeriodo = new CatVencimientosInput();
  
    this.catVencimientosLecturasInputPeriodo._anio = this.anioSeleccionado.anio;
    this.catVencimientosLecturasInputPeriodo._zona = this.ruta.id.toString();
    this.catVencimientosLecturasInputPeriodo._idPeriodo = this.PeriodoSeleccionado.id;
    
    const datoRetorno = await this.vencimientosLecturaService.getBusquedas(this.catVencimientosLecturasInputPeriodo).toPromise();
    if (!datoRetorno) return;

    this.bimestre = datoRetorno;
    this.bimestre.unshift({ numRow: null, anio: null, periodo: 'SELECCIONA...' });
  
  }

  async getTipoPeriodo() {
    this.catTipoperiodo = []
    this.PeriodoSeleccionado = null;
    const datoRetorno = await this.catTipoPeriodoService.getAll().toPromise();
    const id_tipo_periodo = JSON.parse(this.ruta.dato)?.id_tipo_periodo;

    if(id_tipo_periodo){ // Si ya esta definido que tipo de periodo le corresonde a una ruta, solo se carga ese tipo de periodo, en otro caso, se cargan todos.
        this.catTipoperiodo =  datoRetorno.filter(x => x.id === JSON.parse(this.ruta.dato).id_tipo_periodo);
        this.PeriodoSeleccionado = this.catTipoperiodo[0];
    }else 
    {
        this.catTipoperiodo = datoRetorno.filter(x => x.descripcion != "ANUAL" && x.descripcion != "SEMESTRAL");
        this.catTipoperiodo.unshift({ numRow: null, id: null, descripcion: 'SELECCIONA...', baja: false, cambio: false });
    }
  }

  validacionInput(){
    try {
        
        if (this.ruta == null) 
            throw new Error("Debe seleccionar una Ruta.");
        
        if (this.anioSeleccionado == null)
            throw new Error("Debe seleccionar una Año.");
        
        if (this.bimestreSeleccionado == null) 
            throw new Error("Debe seleccionar un Mes o periodo.");
        
        return true

    } catch (e) {
        this.muestraMensaje.error(e, "top", "center");
        return false
    };

  };
  

    // prettier-ignore
    async buscar() {

      try {
        if(!this.validacionInput()) return;

        this.progressBar = true;

        this.FCuentasEnvioMasivoRecibosInput = new FCuentasEnvioMasivoRecibosInput();
        this.FCuentasEnvioMasivoRecibosInput.idRuta = this.ruta.id;
        this.FCuentasEnvioMasivoRecibosInput.anio = Number(this.anioSeleccionado.anio);
        this.FCuentasEnvioMasivoRecibosInput.periodoParcialidad = Number(this.bimestreSeleccionado.periodo);

        const datoRetorno = await this.fCuentasEnvioMasivoRecibosService.getBusquedas(this.FCuentasEnvioMasivoRecibosInput).toPromise();
        this.fCuentasEnvioMasivoRecibos = datoRetorno;
        for (var i = 0, len = this.fCuentasEnvioMasivoRecibos.length; i < len; ++i){
          this.fCuentasEnvioMasivoRecibos[i].numRow = i;
        
        } 
      } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");  
      } finally {
        this.progressBar = false;
        console.log("Paso por getAllFCuentasEnvioMasivoRecibos");
      }
    }

  //===============================================================
  //confirmacion para envio de correos
  //===============================================================
   confirmaEnvio() {

    let selecCheck = this.fCuentasEnvioMasivoRecibos.filter(x => x.check == true);
    let i = 0;
    let e = 0;
    this.CuentasSinCorreo = 0;
    this.CuentasConCorreo = 0;

    if(selecCheck.length == 0){
      this.muestraMensaje.error("No hay cuentas seleccionadas para enviar recibo por correo electronico", "top", "center");
      return;
    }

    this.fcuentasAenviar = [];

    this.fCuentasEnvioMasivoRecibos.forEach(x => {
      let fechaVencimientoString = x.fechaVencimiento;
      let fechaVencimiento =   this.parseFecha(fechaVencimientoString);    // new Date(fechaVencimientoString.replace(/-/g, "/"));
      let fechaActual = new Date();
       
    
      if(x.check == true){

        if (((x.correoElectronico1 != null && x.correoElectronico1 != "") || (x.correoElectronico2 != null && x.correoElectronico2 != "")) &&  fechaActual <=  fechaVencimiento) {
          i++;
          this.CuentasConCorreo = i;
          this.fcuentasAenviar.push(x);
        }
        else {
          e++;
          this.CuentasSinCorreo = e;
        }
      }  
    });

    //solo confirmamos si se dea envia cuentas con correo
    if (this.CuentasConCorreo == 0) {
      this.muestraMensaje.error("No hay cuentas con correo electronico o la fecha de vencimiento ya expiró", "top", "center");
      return;
    }
    
    if(this.CuentasConCorreo == this.fCuentasEnvioMasivoRecibos.length){
            
      this.confirmationService.confirm({
        header: "Confirmación",
        message: "Se enviaran " + this.CuentasConCorreo + " correos, ¿Desea continuar?",
        accept:  () => {  

          let cuentasCorreos: CuentasEnvioRecibos[] = this.fcuentasAenviar.map(x=> ({
            idAgua: x.idAgua, 
            correoElectronico1: x.correoElectronico1, 
            correoElectronico2: x.correoElectronico2,
            cuentaAgua: x.cuentaAgua,
            anio: x.anio,
            periodoParcialidad: x.periodoParcialidad,
            mesPeriodo: x.mesPeriodo,
            propietario: x.propietario,
            domiciolio: x.domiciolio
          }));
          this.enviarFCuentasEnvioMasivoRecibos(cuentasCorreos);
          this.limpiarCheckboxes();
        },
        reject: () => {
          return;
      }
      });
    } else {
        this.confirmationService.confirm({
        header: "Confirmación",
        message: "Solo se enviaran " + this.CuentasConCorreo + " correos cuya fecha de vencimiento no ha expirado, ¿Desea continuar?",
        accept: () => {
          let cuentasCorreos: CuentasEnvioRecibos[]  = this.fcuentasAenviar.map(x=> ({
            idAgua: x.idAgua, 
            correoElectronico1: x.correoElectronico1, 
            correoElectronico2: x.correoElectronico2,
            cuentaAgua: x.cuentaAgua,
            anio: x.anio,
            periodoParcialidad: x.periodoParcialidad,
            mesPeriodo: x.mesPeriodo,
            propietario: x.propietario,
            domiciolio: x.domiciolio
          }));
          this.enviarFCuentasEnvioMasivoRecibos(cuentasCorreos);
          this.limpiarCheckboxes()
        },
        reject: () => {
          return;
      }
      });
    }

    this.onSelectAll(this.fcuentasAenviar);
  }

  //===============================================================
  //Interaccion con los registros de la tabla
  //===============================================================
  // prettier-ignore
  async enviarFCuentasEnvioMasivoRecibos(cuentasEnvioRecibos: CuentasEnvioRecibos[]) {
    try {
      this.progressBar = true;
      const respuesta = await this.fCuentasEnvioMasivoRecibosService.envioCorreoResibosMasivo(cuentasEnvioRecibos).toPromise();
      
      await this.guardarRegistrosCorreosEnviadosRecibos(cuentasEnvioRecibos);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarFCuentasEnvioMasivoRecibos");
      this.progressBar = false;
    }
  }

  async onSelectAll(fCuentasEnvioMasivoRecibos: FCuentasEnvioMasivoRecibos[]) {
    try {
    
      fCuentasEnvioMasivoRecibos.values();
      if (fCuentasEnvioMasivoRecibos == undefined || fCuentasEnvioMasivoRecibos.length === 0) {
        throw new Error("Seleccionar una cuenta primero.");
      } else {
        if (this.numsRows.length === fCuentasEnvioMasivoRecibos.length) {
          this.numsRows = [];
          this.fCuentasEnvioMasivoRecibos.forEach(x => { x.check = false });
        } else {
          fCuentasEnvioMasivoRecibos.forEach(x => { x.check = true });
          let filteredArray = this.fCuentasEnvioMasivoRecibos.filter(item1 =>
            fCuentasEnvioMasivoRecibos.some(item2 => item1.idAgua === item2.idAgua)
          );
          filteredArray.forEach(filteredItem => {
            let correspondingItem = this.fCuentasEnvioMasivoRecibos.find(item => item.idAgua === filteredItem.idAgua);
            correspondingItem.check = true; // Cambia la propiedad 'check' al valor deseado
          });
          this.numsRows = fCuentasEnvioMasivoRecibos.map(renglon => renglon);
        };
      };
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por seleccionar todo");
    };
  };
  
  async onRowSelect(event: any, renglon: any) {
    if (event.target.checked) {
      renglon.check = true;
      this.numsRows.push(renglon);
    } else {
        const index = this.numsRows.indexOf(renglon);
        if (index !== -1) {
          this.numsRows.splice(index, 1);
          renglon.check = false;
      };
    };
  };

  async isRowSelected(renglon: any): Promise<boolean> {

    return this.numsRows.includes(renglon);
  }

  async guardarRegistrosCorreosEnviadosRecibos(cuentasEnvioRecibos: CuentasEnvioRecibos[]) {
    try {

     // this.progressBarRegistro = true;

      cuentasEnvioRecibos.forEach(x => {
         // obtenemos la fecha actual local
         let fechaHoy = new Date()
        this.registrosCorreosEnviadosRecibos = new RegistrosCorreosEnviadosRecibos();
        this.registrosCorreosEnviadosRecibos.id = 0;
        this.registrosCorreosEnviadosRecibos.idAgua = x.idAgua;
        this.registrosCorreosEnviadosRecibos.correoElectronico1 = x.correoElectronico1;
        this.registrosCorreosEnviadosRecibos.correoElectronico2 = x.correoElectronico2;
        this.registrosCorreosEnviadosRecibos.cuentaAgua = x.cuentaAgua;
        this.registrosCorreosEnviadosRecibos.anio = x.anio;
        this.registrosCorreosEnviadosRecibos.periodoParcialidad = x.periodoParcialidad;
        this.registrosCorreosEnviadosRecibos.mesPeriodo = x.mesPeriodo;
        this.registrosCorreosEnviadosRecibos.fechaEnvio =  fechaHoy;
        this.registrosCorreosEnviadosRecibos.idUsuarioEnvio = 0;

        this.addRegistrosCorreosEnviadosRecibos(this.registrosCorreosEnviadosRecibos);
      });

      this.muestraMensaje.notification("envio registrado con éxito", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      //this.progressBarRegistro = false;
    }
  };

  async addRegistrosCorreosEnviadosRecibos(registrosCorreosEnviadosRecibos) {
    try {
      const datoretorno = await this.registrosCorreosEnviadosRecibosService
        .add(registrosCorreosEnviadosRecibos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addRegistrosCorreosEnviadosRecibos");
    };
  }

   parseFecha(fechaString) {
    if (!fechaString) return null;
  
    // Para formato DD-MM-YYYY
    let regexDDMMYYYY = /^\d{2}-\d{2}-\d{4}$/;
    if (regexDDMMYYYY.test(fechaString)) {
      let [dia, mes, anio] = fechaString.split("-");
      // Crear la fecha usando UTC para evitar ajustes de zona horaria
      return new Date(Date.UTC(anio, mes - 1, dia)); // `mes - 1` porque los meses en JavaScript son base 0
    }
  
    // Para formato YYYY-MM-DD
    let regexYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/;
    if (regexYYYYMMDD.test(fechaString)) {
      let [anio, mes, dia] = fechaString.split("-");
      return new Date(Date.UTC(anio, mes - 1, dia)); // Crear en UTC
    }
  
    console.error("Formato de fecha inválido:", fechaString);
    return null;
  }

  limpiarCheckboxes() {
    this.fCuentasEnvioMasivoRecibos.forEach(x => {
      x.check = false;
    });
    this.numsRows = [];
  }

  

}
